import React, { forwardRef } from 'react';
import { useCheckFormSchema } from './hooks/use-check-form-schema.hook';
import { useFormFieldParams } from './hooks/use-form-field-params.hook';

export const TextAreaField = forwardRef<FormFieldActions, TextAreaFieldProps>(({
                                                                                 name,
                                                                                 title,
                                                                                 placeholder,
                                                                                 className,
                                                                               }, ref) => {
  useCheckFormSchema({ name });

  const { inputProps, error, isRequired } = useFormFieldParams({ name });

  return (
    <div className={'form-field ' + className}>
      {title && <label htmlFor={name}>{title} {isRequired && <label>*</label>}</label>}

      {error?.message && <span className={'error-message'}>{error?.message}</span>}

      <textarea
        {...inputProps}
        className={'form-field-input'}
        placeholder={placeholder ?? ''}
        style={{ resize: 'none', width: '100%', minHeight: '300px' }}
      />
    </div>
  );
});

export interface TextAreaFieldProps {
  name: string;
  title?: string;
  value?: string;
  placeholder?: string;
  className?: string;
}